// src/constans/feedback.js

export const FEEDBACK_STATUS_META = {
  open: {
    label: 'Açık',
    chipColor: 'primary',
    background: 'rgba(25, 118, 210, 0.12)',
  },
  pending: {
    label: 'Beklemede',
    chipColor: 'warning',
    background: 'rgba(255, 193, 7, 0.18)',
  },
  reviewing: {
    label: 'İnceleniyor',
    chipColor: 'info',
    background: 'rgba(2, 136, 209, 0.16)',
  },
  resolved: {
    label: 'Çözüldü',
    chipColor: 'success',
    background: 'rgba(46, 125, 50, 0.16)',
  },
  closed: {
    label: 'Kapalı',
    chipColor: 'default',
    background: 'rgba(97, 97, 97, 0.12)',
  },
};

export const FEEDBACK_STATUS_ORDER = ['open', 'pending', 'reviewing', 'resolved', 'closed'];

export const FEEDBACK_STATUS_OPTIONS = FEEDBACK_STATUS_ORDER.map((value) => ({
  value,
  label: FEEDBACK_STATUS_META[value]?.label ?? value,
}));

export const FEEDBACK_CATEGORY_OPTIONS = [
  { value: 'client_boost', label: 'Müşteri Boostu' },
  { value: 'campaigns', label: 'Kampanyalar' },
  { value: 'support_experience', label: 'Destek Deneyimi' },
  { value: 'other', label: 'Diğer' },
];
